exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step--extras .extras-personalize{margin-top:3.5rem}.step--extras .extras-personalize hr{border-color:#000}.step--extras .v-radio>.v-label{font-family:Avenir;font-size:20px;font-weight:900;font-stretch:normal;font-style:normal;line-height:1.45;letter-spacing:normal;color:#000}.step--extras .list-item{font-family:Avenir-Roman;font-weight:400;line-height:1.5}.step--extras .list-item,.step--extras .price{font-size:16px;font-stretch:normal;font-style:normal;letter-spacing:normal;color:#000}.step--extras .price{font-family:Avenir;font-weight:900;line-height:1.63;text-align:right}", ""]);

// exports
exports.locals = {
	"navy": "#001d38",
	"turquoiseBlue": "#00adbc",
	"white": "#fff",
	"black": "#000",
	"error": "#b71c1c",
	"cancel": "#f75b4a",
	"success": "#7ed321"
};